import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import axios from "axios";
import { Layout } from "../layout/Layout";
import '../componen/mapscss/Maps.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const kecamatanDesa = {
  "Taliwang": ["Menala", "Dalam", "Sampir", "Kuang", "Bugis", "Arab Kenangan", "Telaga Bertong", "Tamekan", "Seloto", "Lamunga", "Batu Putih", "Banjar", "Sermong", "Labuhan Kertasari", "Labuhan Lalar", "Lalar Liang"],
  "Seteluk": ["Seteluk Tengah", "Seteluk Atas", "Seran", "Rempe", "Tapir", "Air Suning", "Kelanir", "Lamusung", "Desa Loka", "Meraran"],
  "Poto Tano": ["Poto Tano", "Kokarlian", "Tambak Sari", "Tebo", "Senayan", "Kiantar", "Tuananga", "Mantar"],
  "Brang Rea": ["Lamuntet", "Rarak Ronges", "Bangkat Monteh", "Moteng", "Tepas Sepakat", "Tepas", "Sapugara Bree", "Seminar Salit", "Desa Beru"],
  "Brang Ene": ["Lampok", "Mujahidin", "Kalimantong", "Manemeng", "Mataiyang", "Mura"],
  "Jereweh": ["Dasan Anyar", "Goa", "Beru", "Belo"],
  "Maluk": ["Benete", "Bukit Damai", "Mantun", "Pasir Putih", "Maluk"],
  "Sekongkang": ["Talonang Baru", "Tatar", "Ai Kangkung", "Sekongkang Atas", "Tongo", "Kemuning", "Sekongkang Bawah"],
};

// Fungsi untuk menentukan warna berdasarkan status rumah
const getStatusColor = (status) => {
  if (status === "Rumah Layak Huni" || status === "layak huni") {
    return "#4CAF50"; // Hijau
  } else if (status === "Rumah Tidak Layak Huni" || status === "tidak layak huni") {
    return "#F44336"; // Merah
  }
  return "#FF9800"; // Orange untuk status lain/default
};

// Fungsi untuk membuat icon berdasarkan status
const getStatusIcon = (status, isBacklog = false) => {
  if (isBacklog) {
    return getBacklogIcon();
  }
  
  const color = getStatusColor(status);
  const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 36" width="36" height="36">
    <path fill="${color}" stroke="#000" strokeWidth="1" d="M12 0C7.6 0 3.6 3.9 3.6 8.7c0 2.4 1 4.6 2.5 6.5L12 24l5.9-8.8c1.5-1.9 2.5-4.1 2.5-6.5C20.4 3.9 16.4 0 12 0zm0 12c-1.9 0-3.4-1.5-3.4-3.3s1.5-3.3 3.4-3.3 3.4 1.5 3.4 3.3S13.9 12 12 12z"/>
  </svg>`;
  return L.divIcon({
    className: "custom-leaflet-marker",
    html: svgIcon,
    iconSize: [36, 36],
    iconAnchor: [18, 36],
    popupAnchor: [0, -34],
  });
};

const getBacklogIcon = () => {
  const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 36" width="36" height="36">
    <path fill="#ff6b6b" stroke="#d63031" strokeWidth="2" d="M12 0C7.6 0 3.6 3.9 3.6 8.7c0 2.4 1 4.6 2.5 6.5L12 24l5.9-8.8c1.5-1.9 2.5-4.1 2.5-6.5C20.4 3.9 16.4 0 12 0zm0 12c-1.9 0-3.4-1.5-3.4-3.3s1.5-3.3 3.4-3.3 3.4 1.5 3.4 3.3S13.9 12 12 12z"/>
    <text x="12" y="10" fill="white" font-size="8" font-weight="bold" text-anchor="middle">B</text>
  </svg>`;
  return L.divIcon({
    className: "custom-leaflet-marker backlog-marker",
    html: svgIcon,
    iconSize: [36, 36],
    iconAnchor: [18, 36],
    popupAnchor: [0, -34],
  });
};

const getCoordinates = (item) => {
  const koordinat = item.titikKoordinatRumah || item.manualTitikKoordinatRumah;
  if (!koordinat || koordinat === "-" || koordinat.trim() === "") return null;
  if (koordinat.includes(",")) {
    const [lat, lng] = koordinat.split(",").map((c) => parseFloat(c.trim()));
    return !isNaN(lat) && !isNaN(lng) ? [lat, lng] : null;
  }
  return null;
};

// KSB bounds - filter koordinat yang jelas salah
const KSB_BOUNDS = { minLat: -9.15, maxLat: -8.25, minLng: 116.55, maxLng: 117.35 };

const isCoordinateInKSB = (coords) => {
  if (!coords || coords.length !== 2) return false;
  const [lat, lng] = coords;
  return lat >= KSB_BOUNDS.minLat && lat <= KSB_BOUNDS.maxLat &&
         lng >= KSB_BOUNDS.minLng && lng <= KSB_BOUNDS.maxLng;
};

const kategoriOptions = [
  { value: "", label: "-- Pilih Kategori --" },
  { value: "Bisa Dapat Bantuan", label: "Layak Menerima Bantuan" },
  { value: "Belum Bisa Dapat Bantuan", label: "Belum Layak Menerima Bantuan" },
];

function Maps() {
  const [selectedKecamatan, setSelectedKecamatan] = useState("");
  const [data, setData] = useState([]);
  const [source, setSource] = useState("questionnaire");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedKategori, setSelectedKategori] = useState("");
  const [showBacklog, setShowBacklog] = useState(false);

  const handleSourceChange = (newSource) => {
    setSource(newSource);
    setSelectedKategori("");
    setSelectedStatus("");
    setShowBacklog(false);
    setData([]);
  };

  const handleBacklogChange = (checked) => {
    setShowBacklog(checked);
    if (checked) setSelectedStatus("");
  };

  useEffect(() => {
    if (!selectedKecamatan) return;

    const abortController = new AbortController();
    const currentRequestId = Date.now();
    const latestRequestIdRef = (Maps.latestRequestIdRef = Maps.latestRequestIdRef || { value: 0 });
    latestRequestIdRef.value = currentRequestId;

    const fetchData = async () => {
      try {
        const params = new URLSearchParams({ kecamatan: selectedKecamatan, source });

        if (source === "verifikasi") {
          if (selectedKategori) params.append("kategori", selectedKategori);
        } else {
          if (selectedStatus && !showBacklog) params.append("status", selectedStatus);
          if (showBacklog) params.append("backlog", "true");
        }

        const url = `${process.env.REACT_APP_URL}/maps?${params.toString()}`;

        const response = await axios.get(url, {
          withCredentials: true,
          signal: abortController.signal,
        });

        if (latestRequestIdRef.value !== currentRequestId) return;
        setData(response.data.data || []);
      } catch (error) {
        if (abortController.signal.aborted) return;
        console.error("Gagal mengambil data:", error);
        setData([]);
      }
    };

    fetchData();
    return () => abortController.abort();
  }, [selectedKecamatan, source, selectedKategori, selectedStatus, showBacklog]);

  // Hitung marker yang tampil (valid KSB)
  const visibleCount = data.filter((item) => {
    const coords = getCoordinates(item);
    return coords && isCoordinateInKSB(coords);
  }).length;

  // Hitung statistik berdasarkan status
  const statusStats = data.reduce((acc, item) => {
    const status = item.status || item.kategori || '';
    if (status === "Rumah Layak Huni" || status === "layak huni") {
      acc.layak++;
    } else if (status === "Rumah Tidak Layak Huni" || status === "tidak layak huni") {
      acc.tidakLayak++;
    }
    return acc;
  }, { layak: 0, tidakLayak: 0 });

  return (
    <Layout noContentPadding={true}>
      <div className="map-controls">
        <div className="map-filter">
          <label htmlFor="source-select">Sumber Data:</label>
          <select id="source-select" value={source} onChange={(e) => handleSourceChange(e.target.value)}>
            <option value="questionnaire">Pendataan dan Verifikasi Rehab Rumah</option>
            <option value="verifikasi">Validasi Bangun Baru</option>
          </select>

          <label htmlFor="kecamatan-select">Pilih Kecamatan:</label>
          <select id="kecamatan-select" value={selectedKecamatan} onChange={(e) => setSelectedKecamatan(e.target.value)}>
            <option value="">-- Pilih --</option>
            {Object.keys(kecamatanDesa).map((kec) => (
              <option key={kec} value={kec}>{kec}</option>
            ))}
          </select>

          {source === "verifikasi" ? (
            <select id="kategori-select" value={selectedKategori} onChange={(e) => setSelectedKategori(e.target.value)}>
              {kategoriOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          ) : (
            <div className="questionnaire-filters">
              <select
                id="status-select"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
                disabled={showBacklog}
                style={{ opacity: showBacklog ? 0.6 : 1 }}
              >
                <option value="">-- Pilih Status Rumah --</option>
                <option value="Rumah Layak Huni">Rumah Layak Huni</option>
                <option value="Rumah Tidak Layak Huni">Rumah Tidak Layak Huni</option>
              </select>

              <div className="backlog-filter" style={{ marginTop: "10px", marginBottom: "10px" }}>
                <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <input type="checkbox" checked={showBacklog} onChange={(e) => handleBacklogChange(e.target.checked)} />
                  <span style={{ fontWeight: showBacklog ? "bold" : "normal", color: showBacklog ? "#d63031" : "inherit" }}>
                    Tampilkan hanya Backlog (Jumlah KK Lebih Dari 1)
                  </span>
                </label>
              </div>
            </div>
          )}

          {data.length > 0 && (
            <div className="data-info" style={{ marginTop: "10px", padding: "8px", backgroundColor: "#f0f0f0", borderRadius: "4px", fontSize: "14px" }}>
              <strong>📍 {visibleCount} marker ditampilkan</strong>
              {!showBacklog && source === "questionnaire" && (
                <div style={{ marginTop: "5px", display: "flex", gap: "15px" }}>
                  <span style={{ color: "#4CAF50" }}>🟢 Layak Huni: {statusStats.layak}</span>
                  <span style={{ color: "#F44336" }}>🔴 Tidak Layak: {statusStats.tidakLayak}</span>
                </div>
              )}
              {showBacklog && (
                <div style={{ color: "#d63031", fontWeight: "bold", marginTop: "5px" }}>🏠 Mode Backlog</div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Legend */}
      {source === "questionnaire" && !showBacklog && (
        <div style={{ 
          position: 'absolute', 
          bottom: 30, 
          right: 30, 
          zIndex: 1000,
          backgroundColor: 'white',
          padding: '10px 15px',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
          fontSize: '14px'
        }}>
          <div style={{ marginBottom: '5px', fontWeight: 'bold' }}>Legenda:</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '5px' }}>
            <span style={{ color: '#4CAF50', fontSize: '20px' }}>●</span>
            <span>Rumah Layak Huni</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ color: '#F44336', fontSize: '20px' }}>●</span>
            <span>Rumah Tidak Layak Huni</span>
          </div>
        </div>
      )}

      <div className="map-container">
        <MapContainer
          center={[-8.764796, 116.942187]}
          zoom={10}
          className="leaflet-container"
          style={{ height: "100%", width: "100%" }}
        >
          <TileLayer
            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
            attribution='&copy; <a href="https://www.esri.com/">Esri</a>'
          />

          {data.map((item) => {
            const coordinates = getCoordinates(item);
            if (!coordinates || !isCoordinateInKSB(coordinates)) return null;

            const isBacklog = item.jumlahKK > 1;
            const status = item.status || item.kategori || '';
            const icon = showBacklog || isBacklog 
              ? getBacklogIcon() 
              : getStatusIcon(status, false);

            return (
              <Marker key={item.id} position={coordinates} icon={icon}>
                <Popup>
                  <div style={{ minWidth: 220 }}>
                    <p><strong>Nama:</strong> {item.namaLengkapKK || item.namaKepalaKeluarga}</p>
                    <p><strong>Alamat:</strong> {item.alamatRumah || item.alamat}</p>
                    <p><strong>Kecamatan:</strong> {item.kecamatan}</p>
                    <p><strong>Desa/Kelurahan:</strong> {item.desaKelurahan || "Tidak tersedia"}</p>
                    <p>
                      <strong>Kategori Rumah:</strong>{" "}
                      <span style={{
                        color: status === "Rumah Layak Huni" ? "#4CAF50" :
                               status === "Rumah Tidak Layak Huni" ? "#F44336" : "inherit",
                        fontWeight: "bold"
                      }}>
                        {status || item.kategori || "-"}
                      </span>
                    </p>
                    {source === "questionnaire" && item.jumlahKK && (
                      <p>
                        <strong>Jumlah KK:</strong>{" "}
                        <span style={{ color: item.jumlahKK > 1 ? "#d63031" : "inherit", fontWeight: item.jumlahKK > 1 ? "bold" : "normal" }}>
                          {item.jumlahKK}{item.jumlahKK > 1 && " (Backlog)"}
                        </span>
                      </p>
                    )}
                    {item.Admin?.username && (
                      <p><strong>Surveyor:</strong> {item.Admin.username}</p>
                    )}

                    {(item.bantuan || item.jenisBantuan || item.nominalBantuan) ? (
                      <div style={{ marginTop: 8, paddingTop: 8, borderTop: "1px solid #ddd" }}>
                        <p style={{ marginBottom: 4, fontWeight: 700 }}>Data Bantuan</p>
                        <p><strong>Jenis Bantuan:</strong> {item.jenisBantuan || item.bantuan?.JenisBantuan || "-"}</p>
                        <p><strong>Anggaran:</strong> {
                          (item.nominalBantuan ?? item.bantuan?.nominal) != null
                            ? new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(item.nominalBantuan ?? item.bantuan?.nominal)
                            : "-"
                        }</p>
                        <p><strong>Tanggal Bantuan:</strong> {
                          (item.tanggalBantuan || item.bantuan?.tanggalBantuan)
                            ? new Date(item.tanggalBantuan || item.bantuan?.tanggalBantuan).toLocaleDateString("id-ID")
                            : "-"
                        }</p>
                        {(item.tanggalSelesai || item.bantuan?.tanggalSelesai) && (
                          <p><strong>Tanggal Selesai:</strong> {
                            new Date(item.tanggalSelesai || item.bantuan?.tanggalSelesai).toLocaleDateString("id-ID")
                          }</p>
                        )}
                        <p><strong>Status Proses:</strong> {item.statusProses || item.bantuan?.ProsesBantuan?.statusProses || "-"}</p>
                        {(item.presentase ?? item.bantuan?.Presentase?.presentase) != null && (
                          <p><strong>Progress:</strong> {item.presentase ?? item.bantuan?.Presentase?.presentase}%</p>
                        )}
                      </div>
                    ) : (
                      <p style={{ marginTop: 8, color: "#888" }}><em>Belum ada data bantuan</em></p>
                    )}
                  </div>
                </Popup>
              </Marker>
            );
          })}
        </MapContainer>
      </div>
    </Layout>
  );
}

export default Maps;